<!-- Header da Pagina -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-share-alt"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ 'indicacoes.titulo' | translate }}</h1>
    <p class="header-subtitle">{{ 'indicacoes.subtitulo' | translate }}</p>
  </div>
</div>

<div class="page-body">
  <ng-container [ngTemplateOutlet]="tplMisReferidos"></ng-container>
</div>

<!-- =================================================================== -->
<!-- Template: Meus referidos (visao do proprio usuario)                 -->
<!-- =================================================================== -->
<ng-template #tplMisReferidos>

  <!-- Empilha os cards com espacamento consistente tanto na visao direta
       (nao-master) quanto dentro da aba (master), pois o gap do .page-body
       nao alcanca os cards renderizados dentro do p-tabView. -->
  <div class="mis-referidos-cards">

  <!-- Card: Meu link de indicacao -->
  <div class="form-card">
    <div class="card-header">
      <div class="card-header-icon">
        <i class="pi pi-link"></i>
      </div>
      <span class="card-header-title">{{ 'indicacoes.meu_link' | translate }}</span>
    </div>

    <div class="card-content">
      <!-- Loading inicial (E3) -->
      <div *ngIf="cuponsLoading" class="estado-inline">
        <i class="pi pi-spinner pi-spin"></i>
      </div>

      <!-- Erro no load inicial (E3): sem resumo carregado -->
      <div *ngIf="!cuponsLoading && resumoErro && !resumoEscopo" class="estado-inline estado-erro">
        <span>{{ 'indicacoes.seletor.erro_carregar' | translate }}</span>
        <button pButton
          icon="pi pi-refresh"
          class="p-button-text btn-sm"
          (click)="carregarMeusCupons()">
        </button>
      </div>

      <!-- Conteudo: seletor de cupom + card por escopo -->
      <div *ngIf="!cuponsLoading && resumoEscopo" class="link-content">
        <!-- Seletor de cupom: "Geral" + cupons ativos (E3) -->
        <div class="seletor-cupom-row">
          <label class="seletor-cupom-label" for="seletorCupom">
            {{ 'indicacoes.seletor.label' | translate }}
          </label>
          <!-- Campo + botao informativo andam juntos: o icone pertence ao seletor,
               entao nao pode herdar o gap da linha nem se separar dele ao quebrar. -->
          <div class="seletor-cupom-campo">
            <p-dropdown
              inputId="seletorCupom"
              [options]="escopoOptions"
              optionLabel="label"
              optionValue="value"
              [(ngModel)]="cupomSelecionadoId"
              (onChange)="onEscopoChange()"
              [disabled]="resumoLoading"
              styleClass="seletor-cupom-dropdown"
              [attr.aria-label]="'indicacoes.seletor.label' | translate">
            </p-dropdown>

            <!-- Botao informativo: como funciona o desconto e a comissao -->
            <button pButton
              type="button"
              icon="pi pi-info-circle"
              class="p-button-text p-button-rounded p-button-sm btn-info-comissao"
              [pTooltip]="'indicacoes.como_funciona.botao' | translate"
              tooltipPosition="top"
              [attr.aria-label]="'indicacoes.como_funciona.botao' | translate"
              (click)="infoDialogVisivel = true">
            </button>
          </div>
        </div>

        <!-- Escopo CUPOM: codigo + Desconto/Comissao/Pago + link/Copiar -->
        <ng-container *ngIf="!escopoGeral">
          <div class="codigo-row">
            <span class="codigo-label">{{ 'indicacoes.codigo' | translate }}:</span>
            <span class="codigo-valor">{{ codigoIndicacao }}</span>
            <span class="codigo-vencido-tag" *ngIf="escopoVencido">({{ 'indicacoes.cupom_detalhe.vencido' | translate }})</span>

            <!-- Parametros do cupom, ao lado do codigo: desconto, comissao, repasse -->
            <span class="cupom-detalhes"
              *ngIf="porcentagemDesconto != null || porcentagemComissao != null || tipoPeriodo">
              <span class="cupom-detalhe" *ngIf="porcentagemDesconto != null">
                <span class="cupom-detalhe-label">{{ 'indicacoes.cupom_detalhe.desconto' | translate }}:</span>
                <span class="cupom-detalhe-valor">{{ porcentagemDesconto }}%</span>
              </span>
              <span class="cupom-detalhe" *ngIf="porcentagemComissao != null">
                <span class="cupom-detalhe-label">{{ 'indicacoes.cupom_detalhe.comissao' | translate }}:</span>
                <span class="cupom-detalhe-valor">{{ porcentagemComissao }}%</span>
              </span>
              <span class="cupom-detalhe" *ngIf="tipoPeriodo">
                <span class="cupom-detalhe-label">{{ 'indicacoes.cupom_detalhe.tipo_periodo' | translate }}:</span>
                <span class="cupom-detalhe-valor">{{ tipoPeriodoLabel(tipoPeriodo) }}</span>
              </span>
              <span class="cupom-detalhe" *ngIf="dataValidade">
                <span class="cupom-detalhe-label">{{ 'indicacoes.cupom_detalhe.validade' | translate }}:</span>
                <span class="cupom-detalhe-valor" *ngIf="!cupomSemValidade(dataValidade)">{{ formatarData(dataValidade) }}</span>
                <span class="cupom-detalhe-valor" *ngIf="cupomSemValidade(dataValidade)">{{ 'indicacoes.cupom_detalhe.sem_expiracao' | translate }}</span>
              </span>
            </span>
          </div>

          <div class="link-row" *ngIf="!escopoVencido">
            <input type="text" pInputText
              class="link-input"
              [value]="linkDeIndicacao"
              readonly
              [attr.aria-label]="'indicacoes.meu_link' | translate" />
            <button pButton
              [label]="'indicacoes.copiar_link' | translate"
              icon="pi pi-copy"
              class="btn-primary"
              [attr.aria-label]="'indicacoes.copiar_link' | translate"
              (click)="copiarLink()">
            </button>
          </div>

          <!-- Cupom vencido: sem link/compartilhamento; metricas seguem visiveis abaixo -->
          <div class="link-vencido-aviso" *ngIf="escopoVencido">
            <i class="pi pi-exclamation-triangle"></i>
            <span>{{ 'indicacoes.cupom_vencido_sem_compartilhar' | translate }}</span>
          </div>
        </ng-container>

        <!-- Escopo GERAL: orienta a escolher um cupom para ver o link -->
        <div *ngIf="escopoGeral" class="escopo-geral-hint">
          {{ 'indicacoes.seletor.geral_sem_link' | translate }}
        </div>
      </div>
    </div>
  </div>

  <!-- Card: Tabela de indicacoes (com resumo de totais no topo) -->
  <div class="table-card">
    <div class="card-header">
      <div class="card-header-icon table-icon">
        <i class="pi pi-users"></i>
      </div>
      <span class="card-header-title">{{ 'indicacoes.tabela.titulo' | translate }}</span>

      <div class="card-header-actions">
        <button pButton
          [label]="'indicacoes.whatsapp.botao' | translate"
          icon="pi pi-whatsapp"
          class="btn-whatsapp btn-sm"
          [disabled]="cuponsLoading || resumoLoading || !linkDeIndicacao || escopoVencido"
          (click)="compartilharWhatsApp()">
        </button>
        <button pButton
          [label]="'indicacoes.convite.abrir' | translate"
          icon="pi pi-plus"
          class="btn-primary btn-sm"
          [disabled]="escopoVencido"
          (click)="abrirDialogConvite()">
        </button>
      </div>
    </div>

    <div class="card-content">
      <!-- Resumo de totais (tiles no topo do card) — dirigidos pelo escopo (E3/E4) -->
      <div *ngIf="(cuponsLoading || resumoLoading) && !resumoEscopo" class="estado-inline">
        <i class="pi pi-spinner pi-spin"></i>
      </div>

      <div *ngIf="resumoEscopo as re" class="resumo-grid">
        <div class="resumo-item">
          <span class="resumo-valor">{{ re.resumo.totalIndicacoes }}</span>
          <span class="resumo-rotulo">{{ 'indicacoes.resumo.total_indicacoes' | translate }}</span>
          <span class="resumo-ranking" *ngIf="ranking">
            <i class="pi pi-trophy"></i>
            {{ 'indicacoes.resumo.ranking_posicao' | translate: { posicao: ranking.posicaoPorIndicacoes, total: ranking.totalEmpresas } }}
          </span>
        </div>
        <div class="resumo-item">
          <span class="resumo-valor">{{ re.resumo.totalConfirmadas }}</span>
          <span class="resumo-rotulo">{{ 'indicacoes.resumo.total_confirmadas' | translate }}</span>
          <span class="resumo-ranking" *ngIf="ranking">
            <i class="pi pi-trophy"></i>
            {{ 'indicacoes.resumo.ranking_posicao' | translate: { posicao: ranking.posicaoPorConfirmadas, total: ranking.totalEmpresas } }}
          </span>
        </div>
        <div class="resumo-item">
          <span class="resumo-valor">{{ re.resumo.comissaoAcumuladaTotal | guaraniFormat }}</span>
          <span class="resumo-rotulo">{{ 'indicacoes.resumo.comissao_acumulada' | translate }}</span>
          <span class="resumo-ranking" *ngIf="ranking">
            <i class="pi pi-trophy"></i>
            {{ 'indicacoes.resumo.ranking_posicao' | translate: { posicao: ranking.posicaoPorComissaoAcumulada, total: ranking.totalEmpresas } }}
          </span>
        </div>
        <div class="resumo-item">
          <span class="resumo-valor">{{ re.resumo.comissaoPendenteTotal | guaraniFormat }}</span>
          <span class="resumo-rotulo">{{ 'indicacoes.resumo.comissao_pendente' | translate }}</span>
          <span class="resumo-ranking" *ngIf="ranking">
            <i class="pi pi-trophy"></i>
            {{ 'indicacoes.resumo.ranking_posicao' | translate: { posicao: ranking.posicaoPorComissaoAReceber, total: ranking.totalEmpresas } }}
          </span>
        </div>
        <div class="resumo-item">
          <span class="resumo-valor">{{ re.resumo.comissaoPagaTotal | guaraniFormat }}</span>
          <span class="resumo-rotulo">{{ 'indicacoes.resumo.comissao_paga' | translate }}</span>
          <span class="resumo-ranking" *ngIf="ranking">
            <i class="pi pi-trophy"></i>
            {{ 'indicacoes.resumo.ranking_posicao' | translate: { posicao: ranking.posicaoPorComissaoRecebida, total: ranking.totalEmpresas } }}
          </span>
        </div>
      </div>

      <!-- `tabela-espacada-sm`: classe global opt-in (styles.scss) que da respiro as
           celulas. Sem ela o padrao do sistema e `0px 5px`, e as tags de Situacao
           de linhas seguidas ficam praticamente encostadas. -->
      <p-table [value]="indicacoes"
        [lazy]="true"
        (onLazyLoad)="onLazyLoad($event)"
        [rows]="rows"
        [first]="first"
        [totalRecords]="totalRecords"
        [loading]="loading"
        styleClass="tabela-espacada-sm"
        [tableStyle]="{ width: '100%' }">

        <ng-template pTemplate="header">
          <tr>
            <th style="width: 28%" pSortableColumn="emailIndicado">
              {{ 'indicacoes.tabela.email_indicado' | translate }}<p-sortIcon [field]="'emailIndicado'"></p-sortIcon>
            </th>
            <th style="width: 15%" pSortableColumn="status">
              {{ 'indicacoes.tabela.status' | translate }}<p-sortIcon [field]="'status'"></p-sortIcon>
            </th>
            <th style="width: 14%" pSortableColumn="origem">
              {{ 'indicacoes.tabela.origem' | translate }}<p-sortIcon [field]="'origem'"></p-sortIcon>
            </th>
            <th style="width: 22%">{{ 'indicacoes.tabela.comissao' | translate }}</th>
            <th style="width: 21%">{{ 'indicacoes.tabela.status_repasse' | translate }}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-indicacao>
          <tr>
            <td>{{ indicacao.emailIndicado }}</td>
            <td>
              <p-tag
                [value]="labelStatusIndicacao(indicacao.status)"
                [severity]="severityStatusIndicacao(indicacao.status)">
              </p-tag>
            </td>
            <td>
              <span class="origem-cell">
                <i *ngIf="iconeOrigem(indicacao.origem)" [class]="iconeOrigem(indicacao.origem)"></i>
                <span>{{ labelOrigem(indicacao.origem) }}</span>
              </span>
            </td>
            <td>{{ indicacao.comissaoAcumulada | guaraniFormat }}</td>
            <td>
              <p-tag *ngIf="indicacao.statusRepasse"
                [value]="labelStatusRepasseResumo(indicacao.statusRepasse)"
                [severity]="severityStatusRepasse(indicacao.statusRepasse)">
              </p-tag>
              <span *ngIf="!indicacao.statusRepasse">-</span>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5" class="text-center p-5">
              <div class="flex flex-column align-items-center">
                <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
                <div class="text-gray-500 text-lg">{{ 'indicacoes.tabela.vazio' | translate }}</div>
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="loadingbody">
          <tr>
            <td colspan="5" class="text-center p-5">
              <div class="flex justify-content-center align-items-center">
                <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
                <span class="ml-3">{{ 'indicacoes.tabela.carregando' | translate }}</span>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <!-- Paginacao (tabela lazy: a troca de pagina recarrega do backend) -->
      <div class="pagination-container">
        <div>
          <p-paginator
            (onPageChange)="onPageChange($any($event))"
            [showCurrentPageReport]="true"
            [currentPageReportTemplate]="'indicacoes.tabela.contagem' | translate"
            [first]="first" [rows]="rows"
            [totalRecords]="totalRecords" [showFirstLastIcon]="true">
          </p-paginator>
        </div>
        <div class="flex align-items-center">
          <span class="mx-1 text-color">{{ 'indicacoes.tabela.itens_por_pagina' | translate }}</span>
          <p-dropdown [options]="pageSizeOptions" optionLabel="label"
            optionValue="value" [(ngModel)]="rows"
            (ngModelChange)="onRowsPerPageChange()" styleClass="w-6rem"
            appendTo="body">
          </p-dropdown>
        </div>
      </div>
    </div>
  </div>
  </div>
</ng-template>


<!-- =================================================================== -->
<!-- Dialog: Convidar amigo (wave header --info)                         -->
<!-- =================================================================== -->
<p-dialog
  [(visible)]="conviteDialogVisivel"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '32rem' }">

  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-send" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'indicacoes.convite.titulo' | translate }}</h2>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p class="convite-descricao">{{ 'indicacoes.convite.descricao' | translate }}</p>

    <div class="form-field full">
      <label class="form-label">
        {{ 'indicacoes.convite.email' | translate }} <span class="required">*</span>
      </label>
      <input type="email" pInputText
        class="w-full"
        [(ngModel)]="conviteEmail"
        [placeholder]="'indicacoes.convite.email_placeholder' | translate"
        (keydown.enter)="submitConvite()"
        autocomplete="off" />
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton
      [label]="'indicacoes.convite.cancelar' | translate"
      class="p-button-secondary"
      [disabled]="enviandoConvite"
      (click)="fecharDialogConvite()">
    </button>
    <button pButton
      [label]="'indicacoes.convite.enviar' | translate"
      icon="pi pi-send"
      class="btn-primary"
      style="gap: 0.35rem"
      [disabled]="enviandoConvite"
      [loading]="enviandoConvite"
      (click)="submitConvite()">
    </button>
  </ng-template>
</p-dialog>

<!-- =================================================================== -->
<!-- Dialog: Detalhe da indicacao (drill-down)                           -->
<!-- =================================================================== -->
<p-dialog
  [(visible)]="detalheDialogVisivel"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '44rem' }"
  (onHide)="fecharDetalhe()">

  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-list" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'indicacoes.detalhe.titulo' | translate }}</h2>
        <p class="dialog-wave-subtitle" *ngIf="indicacaoSelecionada">
          {{ indicacaoSelecionada.emailIndicado }}
        </p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p class="detalhe-descricao">{{ 'indicacoes.detalhe.descricao' | translate }}</p>

    <!-- Loading -->
    <div *ngIf="carregandoComissoes" class="estado-inline">
      <i class="pi pi-spinner pi-spin" style="font-size: 1.5rem;"></i>
      <span class="ml-2">{{ 'indicacoes.detalhe.carregando' | translate }}</span>
    </div>

    <!-- Empty -->
    <div *ngIf="!carregandoComissoes && comissoes.length === 0" class="estado-vazio">
      <i class="pi pi-inbox text-gray-400" style="font-size: 2.5rem; margin-bottom: 0.75rem;"></i>
      <div class="text-gray-500">{{ 'indicacoes.detalhe.sem_comissoes' | translate }}</div>
    </div>

    <!-- Tabela de competencias -->
    <p-table *ngIf="!carregandoComissoes && comissoes.length > 0"
      [value]="comissoes"
      [tableStyle]="{ width: '100%' }">

      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'indicacoes.detalhe.competencia' | translate }}</th>
          <th>{{ 'indicacoes.detalhe.valor' | translate }}</th>
          <th>{{ 'indicacoes.detalhe.porcentagem' | translate }}</th>
          <th>{{ 'indicacoes.detalhe.repasse' | translate }}</th>
          <th>{{ 'indicacoes.detalhe.acoes' | translate }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-comissao>
        <tr [class.linha-cancelada]="isComissaoCancelada(comissao)">
          <td>{{ formatarCompetencia(comissao.competencia) }}</td>
          <td>{{ comissao.valorComissao | guaraniFormat }}</td>
          <td>{{ comissao.porcentagemComissao }}%</td>
          <td>
            <p-tag
              [value]="labelStatusRepasse(comissao.statusRepasse)"
              [severity]="severityStatusRepasse(comissao.statusRepasse)">
            </p-tag>
            <div class="repassado-em" *ngIf="comissao.statusRepasse === 'PAGA' && comissao.repassadoEm">
              {{ 'indicacoes.detalhe.repassado_em' | translate: { data: formatarData(comissao.repassadoEm) } }}
            </div>
          </td>
          <td class="actions">
            <button *ngIf="podeMarcarPago(comissao)"
              pButton
              [label]="'indicacoes.repasse.marcar_pago' | translate"
              icon="pi pi-check"
              class="btn-primary btn-sm"
              [disabled]="repassandoComissaoId !== null"
              [loading]="repassandoComissaoId === comissao.id"
              (click)="marcarComoPago(comissao)">
            </button>
            <span *ngIf="!podeMarcarPago(comissao)" class="sem-acao">-</span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <ng-template pTemplate="footer">
    <button pButton
      [label]="'indicacoes.detalhe.fechar' | translate"
      class="p-button-secondary"
      (click)="fecharDetalhe()">
    </button>
  </ng-template>
</p-dialog>

<!-- =================================================================== -->
<!-- Dialog: Como funciona o desconto e a comissao (informativo)         -->
<!-- =================================================================== -->
<p-dialog
  [(visible)]="infoDialogVisivel"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign dialog-info-comissao"
  [style]="{ width: '38rem' }">

  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-info-circle" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'indicacoes.como_funciona.titulo' | translate }}</h2>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p class="como-funciona-passo">{{ 'indicacoes.como_funciona.passo1' | translate }}</p>
    <p class="como-funciona-passo">{{ 'indicacoes.como_funciona.passo2' | translate }}</p>
    <ul class="como-funciona-lista">
      <li>{{ 'indicacoes.como_funciona.item_mensal' | translate }}</li>
      <li>{{ 'indicacoes.como_funciona.item_trimestral' | translate }}</li>
      <li>{{ 'indicacoes.como_funciona.item_anual' | translate }}</li>
    </ul>
    <p class="como-funciona-nota">{{ 'indicacoes.como_funciona.nota' | translate }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton
      [label]="'indicacoes.como_funciona.fechar' | translate"
      class="btn-primary"
      (click)="infoDialogVisivel = false">
    </button>
  </ng-template>
</p-dialog>


<p-toast />
